import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ConfirmProcessProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  buildingAcronym: string;
}

function ConfirmProcess(props: ConfirmProcessProps) {
  const { open, handleClose, handleConfirm, buildingAcronym } = props;
  const { t } = useTranslation(['process', 'common']);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Processar Custos</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{t('confirmation.processed')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="secondary" onClick={handleClose}>
          {t('common:no')}
        </Button>
        <Button variant="primary" onClick={handleConfirm} autoFocus>
          {t('common:yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmProcess;
